<template>
  <h1 class="text-center mt-5">You are not allowed to view this page</h1>
</template>

<script>
  export default {
    name: "not-allowed"
  }
</script>

<style scoped>

</style>
